import Proj1 from "../assets/proj1.jpg";
import Proj2 from "../assets/proj2.jpg";
import Proj5 from "../assets/proj5.jpg";


export const ProjectList = [
  {
    name: "Built-In Command Shell",
    image: Proj1,
    skills: "Golang, Systems Programming",
    link: "https://github.com/aminaopio/CSCE4600-Project2"
  },
  {
    name: "Meet Me Halfway",
    image: Proj2,
    skills: "Flutter, Dart, Google Maps APIs",
    link: "https://github.com/aminaopio/Meet-Me-Halfway"
  },
  {
    name: "Teamfight Tactics Build Guide",
    image: Proj5,
    skills: "ReactJS,Javascript,CSS",
    link: "https://github.com/isabellewilliams628/TFTBuildGuide"
  },
];